var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('img',{attrs:{"src":require("../assets/dream_it_s.png"),"id":"cover"},on:{"click":function($event){return _vm.onCover()}}}),_c('div',{attrs:{"id":"content"},domProps:{"innerHTML":_vm._s(_vm.html)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }